// extracted by mini-css-extract-plugin
export default {"delivery_img1":"DeliveryService_delivery_img1__+vKSN","delivery_img2":"DeliveryService_delivery_img2__o2CnB"};